import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./CourseProgress.css";

import {
    TrendingUp,
    BookOpen,
    CheckCircle2
} from "lucide-react";


const CourseProgress = () => {

    /* ==============================
       USER
    ============================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ==============================
       COURSE STATUS
    ============================== */

    const [courseStatus, setCourseStatus] =
        useState(null);


    const [loading, setLoading] =
        useState(true);


    /* ==============================
       LOAD COURSE STATUS
    ============================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }

        loadCourseStatus();

    }, [email]);


    const loadCourseStatus = async () => {

        try {

            setLoading(true);

            const res =
                await axios.get(

                    `/api/ignite/course/status/${email}`

                );


            if (res.data.success) {

                setCourseStatus({

                    neuroPerformanceFoundational:
                        res.data.courses
                            ?.neuroPerformanceFoundational || false,

                    eyeHealthAthleticEdition:
                        res.data.courses
                            ?.eyeHealthAthleticEdition || false,

                    eyeHealthDetailed:
                        res.data.courses
                            ?.eyeHealthDetailed || false,

                    allCoursesCompleted:
                        res.data.allCoursesCompleted || false

                });

            }

        }

        catch (err) {

            console.error(

                "Course Progress Error:",

                err

            );

        }

        finally {

            setLoading(false);

        }

    };


    /* ==============================
       LOADING
    ============================== */

    if (loading || !courseStatus) {

        return (

            <div className="course-progress-card">

                Loading...

            </div>

        );

    }


    /* ==============================
       COMPLETED COURSES
    ============================== */

    const completedCourses = [

        courseStatus
            .neuroPerformanceFoundational,

        courseStatus
            .eyeHealthAthleticEdition,

        courseStatus
            .eyeHealthDetailed

    ].filter(Boolean).length;


    const totalCourses = 3;


    /* ==============================
       OVERALL PROGRESS
    ============================== */

    const progress =

        Math.round(

            (

                completedCourses /

                totalCourses

            ) * 100

        );


    const allCompleted =
        completedCourses === totalCourses;


    return (

        <div className="course-progress-card">


            {/* =========================
                HEADER
            ========================= */}

            <div className="course-progress-header">

                <div>

                    <h2>

                        Course Progress

                    </h2>

                    <p>

                        Your Ignite learning progress.

                    </p>

                </div>

                <TrendingUp/>

            </div>


            {/* =========================
                PROGRESS NUMBER
            ========================= */}

            <div className="course-progress-number">

                {progress}%

            </div>


            {/* =========================
                PROGRESS BAR
            ========================= */}

            <div className="course-progress-bar">

                <div

                    className="course-progress-fill"

                    style={{

                        width:
                            `${progress}%`

                    }}

                />

            </div>


            {/* =========================
                COURSE COUNT
            ========================= */}

            <div className="course-progress-list">

                <div>

                    <BookOpen size={18}/>

                    <span>

                        Courses

                    </span>

                    <strong>

                        {completedCourses}

                        /

                        {totalCourses}

                    </strong>

                </div>


                {/* =====================
                    STATUS
                ===================== */}

                <div>

                    <CheckCircle2 size={18}/>

                    <span>

                        Status

                    </span>

                    <strong>

                        {

                            allCompleted

                                ?

                                "Completed"

                                :

                                "In Progress"

                        }

                    </strong>

                </div>

            </div>


        </div>

    );

};


export default CourseProgress;